// @flow strict

import request from 'services/request';

/**
 * Fetches all metals
 */
export const index = () => request('metals', { method: 'GET' });
